module.exports = __webpack_public_path__ + "img/6.dfb1d39d.jpg";